import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CatDrawer } from "blocks-nextjs/blocks-react/components/Drawer";
import { CatHeading } from "blocks-nextjs/blocks-react/components/Heading/Heading";
import React, { useEffect, useState } from "react";
import AssetPageDetail from "../../pages/Projects/AssetPageDetail";
import useProjectDetailsStore from "../../store/useProjectDetailsStore";
const AssetDetailDrawer = ({ assetDrawerActive, onAssetSelect, setAssetDrawerActive }) => {
    const { assetDetails } = useProjectDetailsStore((state) => ({
        assetDetails: state.assetDetails,
        projectName: state.projectDetails?.projectName
    }));
    const [isRefreshComponent, setIsRefreshComponent] = useState(assetDrawerActive);
    useEffect(() => {
        setIsRefreshComponent(assetDrawerActive);
    }, [assetDrawerActive]);
    return (_jsx(CatDrawer, { disableBackdropClick: false, disableEscClick: true, hasBackdrop: true, isActive: assetDrawerActive, onBlDrawerClose: () => {
            setAssetDrawerActive(false);
            onAssetSelect(assetDetails);
        }, onBlDrawerOpen: () => { }, preserveContent: false, width: "60%", children: _jsxs(_Fragment, { children: [_jsx("div", { "data-test": "asset-details-drawer-header", slot: "header", children: _jsx(CatHeading, { "data-test": "asset-details-drawer-title", level: "h1", variant: "title", children: "Asset Details" }) }), _jsx(AssetPageDetail, { isRefreshComponent: isRefreshComponent })] }) }));
};
export default AssetDetailDrawer;
